__turbopack_context__.v({
  "button": "CardScroller-module__N5y3Gq__button",
});
